var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Download_icon",
    "data-name": "Download icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.907,
    height: 23.871,
    viewBox: "0 0 17.907 23.871",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9926",
    "data-name": "Group 9926",
    transform: "translate(0 20.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10417",
    "data-name": "Path 10417",
    d: "M3121.261,1504.732h17.9v2.984h-17.9C3121.252,1507.725,3121.261,1504.732,3121.261,1504.732Z",
    transform: "translate(-3121.257 -1504.732)",
    fill: "#3c3c3b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_36738",
    "data-name": "Path 36738",
    d: "M3245.158,994.495a1.491,1.491,0,1,1,2.983,0v10.679l4.839-4.838,2.109,2.11-8.44,8.44-8.44-8.44,2.109-2.11,4.839,4.838Z",
    transform: "translate(-3237.697 -993.003)",
    fill: "#3c3c3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadicon);
export default __webpack_public_path__ + "static/media/Download icon.4ba866caa89ec4c33a4cf2bb7303b6d0.svg";
export { ForwardRef as ReactComponent };